const getWordPronunciation = (item,that) => {
    let wordAudio = null;

    // 优先获取服务器音频文件
    that.$axios.get("/api/v1/word/audio?word=" + item, {
        headers: {
            isLoading: false
        }
    }).then((res) => {
        console.log(res);

        if (res.data.audioUrl === "") {
            that.$axios.post("/api/tts/convert?text=" + item, {}, {

                headers: {
                    isLoading: false
                }
            }).then((response) => {
                console.log(response, 121);


                if (response.code === 200) {
                    let raw = window.atob(response.data);
                    let rawLength = raw.length;
                    let uInt8Array = new Uint8Array(rawLength);
                    for (let i = 0; i < rawLength; ++i) {
                        uInt8Array[i] = raw.charCodeAt(i);
                    }
                    const boleb= new Blob([uInt8Array]);
                    let objectURL = URL.createObjectURL(boleb);
                    wordAudio = new Audio(objectURL);
                    wordAudio.play();
                } else {
                    that.$message.error(response.msg);
                }

            });
        }else{
            wordAudio = new Audio(res.data.audioUrl);
            wordAudio.play();
        }
    });
}

/**
 * 播放单词发音（支持语速、播放/完成回调，返回 Promise）
 * @param {string} word - 单词
 * @param {Object} that - Vue 实例
 * @param {Object} options - { playbackRate: number, onPlay: Function, onEnd: Function }
 * @returns {Promise<void>}
 */
const getWordPronunciationWithOptions = (word, that, options = {}) => {
    const { playbackRate = 1, onPlay, onEnd } = options;

    return new Promise((resolve, reject) => {
        that.$axios.get("/api/v1/word/audio?word=" + word, {
            headers: { isLoading: false }
        }).then((res) => {
            const playAudio = (audioUrlOrBlob) => {
                const audio = typeof audioUrlOrBlob === 'string'
                    ? new Audio(audioUrlOrBlob)
                    : new Audio(URL.createObjectURL(audioUrlOrBlob));
                audio.playbackRate = playbackRate;
                audio.onended = () => {
                    if (onEnd) onEnd();
                    resolve();
                };
                audio.onerror = (e) => {
                    if (onEnd) onEnd();
                    that.$message && that.$message.error('播放失败');
                    reject(e);
                };
                if (onPlay) onPlay();
                audio.play();
            };

            if (res.data.audioUrl === "") {
                that.$axios.post("/api/tts/convert?text=" + word, {}, {
                    headers: { isLoading: false }
                }).then((axiosRes) => {
                    const body = axiosRes.data;
                    const base64 = (body && body.data) || (typeof body === 'string' ? body : null);
                    if (base64 || (body && body.code === 200)) {
                        const raw = window.atob(base64 || (body && body.data) || '');
                        const uInt8Array = new Uint8Array(raw.length);
                        for (let i = 0; i < raw.length; ++i) {
                            uInt8Array[i] = raw.charCodeAt(i);
                        }
                        const blob = new Blob([uInt8Array]);
                        playAudio(blob);
                    } else {
                        that.$message && that.$message.error((body && body.msg) || 'TTS 转换失败');
                        reject(new Error(body && body.msg));
                    }
                }).catch(reject);
            } else {
                playAudio(res.data.audioUrl);
            }
        }).catch(reject);
    });
};

export {
    getWordPronunciation,
    getWordPronunciationWithOptions
} ;